import { createElementBlock as h, openBlock as e, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 126 24"
};
function n(r, l) {
  return e(), h("svg", o, l[0] || (l[0] = [
    t("path", {
      d: "M0 24h24V0H0ZM7.387 6h2.906v5.547L13.387 6h3.226l-3.36 6 3.36 6h-3.226l-3.067-5.547V18H7.387Zm17.922 18h24V0h-24ZM35.44 6h3.707l3.918 12.027h-3.144l-.535-1.734-4.266-.027L34.586 18h-3.094Zm3.227 7.922h-2.8l1.386-4.48ZM50.641 24h24V0h-24ZM60.746 6l1.945 3.707L64.613 6H68l-3.895 6.719V18h-2.933v-5.309L57.254 6Zm15.227 18h24V0h-24ZM86.105 6h3.707l3.922 12.027h-3.199L90 16.293l-4.266-.027L85.2 18h-3.094Zm3.227 7.922h-2.797l1.387-4.48ZM101.282 0v24h24V0Zm16.613 18h-3.227l-3.066-5.547V18h-2.91V6h2.91v5.547L114.668 6h3.227l-3.336 6Zm0 0",
      style: { stroke: "none", "fill-rule": "nonzero", fill: "#ff690f", "fill-opacity": "1" }
    }, null, -1)
  ]));
}
const m = { render: n };
export {
  m as default,
  n as render
};
//# sourceMappingURL=ic_brand_kayak-r3GFMszz.js.map
